/* eslint-disable max-len */
import {getRolesPantalla} from '@/utils/funtionsGlobals';

export default [
  {
    path: '/MtoUsuariosView',
    name: 'MtoUsuariosView',
    component: () =>
      import('../views/configuracion/gestion-usuarios/UsuariosView.vue'),
    meta: {
      title: 'Buscador Usuarios',
      requiresAuthentication: true,
      requiresAuthorization: false,
      roles: getRolesPantalla('MtoUsuariosView'),
      bread: {
        path: ['Configuración'],
      },
    },
    children: [
      {
        path: 'MtoUsuariosDetalleView/:id?',
        name: 'MtoUsuariosDetalleView',
        component: () =>
          import('../views/configuracion/gestion-usuarios/detalle-gestion-usuarios/GestionUsuariosDetalleSeccionView.vue'),
        meta: {
          title: 'Detalle Usuarios',
          requiresAuthentication: true,
          requiresAuthorization: false,
          roles: getRolesPantalla('MtoUsuariosView'),
          bread: {
            path: [
              'Configuración',
              {
                label: 'Buscador Usuarios',
                routeLocation: {name: 'MtoUsuariosView'},
              },
            ],
          },
        },
      },
    ],
  },
];
